import { Model } from '@vuex-orm/core';

export default class FacilityResidence extends Model {
  static entity = 'facility_residence';

  static primaryKey = ['facility_id', 'residence_id'];

  static fields() {
    return {
      id: this.uid(),
      facility_id: this.attr(null),
      residence_id: this.attr(null),
    };
  }
}
